// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"336":"cbe8824d","949":"98521b4a","968":"88501673"}[chunkId] + ".css";
};